"use client";

import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React from "react";

const getOptimizedSwatchImageSrc = (image: IImage, isSSR: boolean) => {
  return optimizeImageUrl(image, isSSR, {
    width: 360,
    height: 360,
    resizeMethod: "fill",
    dprOverride: 1,
  });
};

export const LoggedOutProductTileSwatches: React.FC<{
  optionDetails?: ILeanProductTile.IOptionsDetails;
}> = ({ optionDetails }) => {
  const isSSR = useIsSSR();
  if (!optionDetails) {
    return null;
  }

  if (optionDetails?.text) {
    return <Typography variant="paragraphSansRegular" className="leading-5" />;
  }

  return (
    <>
      <Spacer size="1/2x" />
      <Row align="center" className="h-5">
        <Row className="-ml-px">
          {optionDetails.swatch_details?.swatch_preview_images.map((image) => (
            <img
              className="-ml-1 h-4 w-4 rounded-full border object-center first:ml-0"
              style={{ borderColor: "white" }}
              src={getOptimizedSwatchImageSrc(image, isSSR)}
              key={image.token}
            />
          ))}
        </Row>
        <Spacer size="1/2x" />
        <Typography variant="paragraphSansRegular">
          {optionDetails.swatch_details?.formatted_remaining_option_count}
        </Typography>
      </Row>
    </>
  );
};
